import React, { forwardRef } from 'react';
import { Typography } from 'antd';
import styles from './BlockWithExtraContent.module.scss';

const { Text } = Typography;

const BlockWithExtraContent = forwardRef(({ main, extra, ...props }, ref) => {
  if (!main) return null;

  return (
    <p
      ref={ref}
      {...props}
      className={styles.root}
    >
      {Boolean(extra) && (
        <>
          <Text className={styles.extra}>{extra}</Text>
          <br />
        </>
      )}
      {main}
    </p>
  );
});

export default BlockWithExtraContent;
